import EmaButton from "components/emaButton/EmaButton";
import { useState } from "react";
import { postElement } from "services/apiEndpoints/Endpoints";
import { useTranslation } from "react-i18next";
import NewUserForm from "./NewUserForm";

const NewUser = ({ setIsOpen, getUsers , isOpen}) => {
  const [newUser, setNewUser] = useState([]);
  const [errors, setFormErrors] = useState([]);
  const { t } = useTranslation();

  // HANDLE CHANGES IN NEW USER FORM
  function handleChange(e) {
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value,
    });
  }
  function handleOnClickSave() {
    postElement(`/Admin/User`, newUser).then((res) => {
      if (res.success) {
        getUsers();
        setIsOpen(false);
      } else if (res.vErrors) {
        setFormErrors(res.vErrors);
      }
    });
  }

  return (
    <div>
      <div className="slider-header">
        <section className="slider-header-title">{t("New User")}</section>
        <section className="slider-header-buttons">
          <EmaButton title={t("Cancel")} onClick={() => setIsOpen(false)} />
          <EmaButton title={t("Save")} btnDark onClick={handleOnClickSave} />
        </section>
      </div>
      <div className="slider-body">
        <NewUserForm
          newUser={newUser}
          handleChange={handleChange}
          errors={errors}
          index={isOpen?.index}
          setNewUser={setNewUser}
        />
      </div>
    </div>
  );
};

export default NewUser;
